// extracted by mini-css-extract-plugin
export default {"main":"ContactPageForm_main__DfQxk","contentCol":"ContactPageForm_contentCol__et+JG","formCol":"ContactPageForm_formCol__R77x+","info":"ContactPageForm_info__badr0"};